import { SelectionCitationEvent, SelectionCitationData, SelectionAny, SelectionWithMultimediaMixin, } from './internal';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionSourceCitation extends SelectionWithMultimediaMixin(SelectionWithNoteMixin(SelectionAny)) {
    getSourceRecord() {
        return this.root().getSourceRecord(this.valueNonNull());
    }
    getLocationInSource() {
        return this.get("PAGE" /* Tag.Page */);
    }
    getEventCitedFrom() {
        return this.get("EVEN" /* Tag.Event */, null, SelectionCitationEvent);
    }
    getData() {
        return this.get("DATA" /* Tag.Data */, null, SelectionCitationData);
    }
    getCertainty() {
        return this.get("QUAY" /* Tag.QualityOfData */);
    }
}
//# sourceMappingURL=SelectionSourceCitation.js.map